import $axios from '~/plugins/axios';
import { buildModule } from '../utils';
import { Api, Warehouse, WarehouseRequest } from '~/api';
import { Dict } from '~/helpers';

const api = $axios as Api;

export default buildModule()
	.withState({
		storedWarehouses: {} as Dict<Warehouse>,
	})
	.withGetters({
		byId: state => (warehouseId: number) => (
			state.storedWarehouses[warehouseId] ?? null
		),
	})
	.withMutations({
		STORE_WAREHOUSE (state, warehouse: Warehouse) {
			state.storedWarehouses = {
				...state.storedWarehouses,
				[warehouse.id]: warehouse,
			};
		},
	})
	.withActions({
		async get ({ commit }, warehouseId: number) {
			const { data } = await api.get(`/warehouse/${ warehouseId }`);

			commit('STORE_WAREHOUSE', data.payload);
		},
		async post ({ commit }, warehouse: WarehouseRequest) {
			const { data } = await api.post('/warehouse', warehouse);

			commit('STORE_WAREHOUSE', data.payload);
		},
		async update ({ commit }, { id, ...warehouse }: {
			id: number;
		} & WarehouseRequest) {
			const { data } = await api.put(`/warehouse/${ id }`, warehouse);

			commit('STORE_WAREHOUSE', data.payload);
		},
	});
